import {AppPageHeader} from "../../../../core/component/page-header";
import {useHistory, useRouteMatch} from 'react-router-dom';
import React, {ReactNode} from "react";

export type HeaderCashFlowProps = {
    createRoute?: string;
    mode?: 'list' | 'form';
    title?: string,
    subtitle?:string,
    extra?: ReactNode[],
}

export function  HeaderCashFlow(props: HeaderCashFlowProps) {
    const urlMatch = useRouteMatch();
    const history = useHistory();

    function getCreateLink(): string {
        return `${urlMatch.url}/create`;
    }

    function getListLink(): string {
        return `list`;
    }
    return (
        <>
            <AppPageHeader
                title={props.title ?? 'Fluxo de Caixa'}
                mode={props.mode}
                subtitle={props.subtitle ?? 'Acompanhamento do Fluxo de Caixa'}
                onListLink={getListLink()}
                onBack={() => history.goBack()}
                extra={props.extra}
            />
        </>
    );

}
